// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview_bg_screen__JzMR6 {
    background-color: #f1f2fb
}



.overview_tabs__i5Wvp {
    /* background-color: white; */
    /* border-radius: 5px */
    margin: 0.7rem
}

.overview_disclaimer__FLst8 {
    font-style: italic
}

.overview_month__vd0xz {
    cursor: pointer;
    color: #1467b3;
    font-size: 20px;
    margin-right: 10px
}

.overview_kpi__E5Dpw {
    box-shadow: 0 4px 6px #cdd5eb;
    height: 100px;
    background-color: white;
    border: 1px solid #83A4CF;
    border-radius: 5px;
    width: 100%
}

.overview_download_button__G9uaQ {
    color: #83a4cf;
    background-color: transparent;
    border: none;
}

.overview_icons__Yxktz {
    background-Color: #e4e8f6;
    border-Radius: 50%;
    padding: 10px;
    /* width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-Content: center;
    margin-Right: 10px; */
}

.overview_number_of_vehicles__0bQdP {
    color: black;
    font-Weight: 700;
    font-size: 20px;
    margin-Bottom: 5px;
}

.overview_vehicles_performance__zRDc2 {
    color: gray;
    font-Weight: 500;
    font-Size: 14px;
    display: flex;
    align-Items: center;
}

.overview_cost_savings_tab__G0Xr4 {
    background-Color: white;
    border-radius: 10px;
    margin-Bottom: 20px;
    border: 1px solid #83A4CF;
    display: flex;
    justify-Content: space-between;
    align-items: center;
    box-Shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.overview_potential_cost_savings__e3PaV {
    color: #364e69;
    font-Weight: bold;
    margin-Bottom: 10px;
}

.overview_potential_cost_savingstext__qmCMQ {
    color: #666;
    font-Size: 14px;
}

.overview_fuel_efficiency_tab__z0k7R {
    background-Color: white;
    border: 1px solid #83A4CF;
    border-Radius: 5px;
    width: 100%;
}

.overview_fuel_efficiency_tabtext__lunqo {
    color: #364e69;
    margin-Bottom: 5px;
}

.overview_parameter_sel_tab__Uxddk {
    border: 1px solid #83A4CF;
    border-Radius: 10px;
    width: 100%;
    background-Color: #e1e6ed;
}

.overview_parameter_distance__FDKDW {
    color: #364e69;
    font-Weight: bold;
    margin-Bottom: 5px;
}

.overview_button_apply__GXIm7 {
    background-Color: #00005f;
    background-Image: linear-gradient(to left, #83a4cf 0%, #83a4cf 100%);
    color: white;
    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease-in-out;
    border: none;

}

.overview_vehicle_details__7hP\\+E {
    border-Radius: 10px;
    overflow: hidden;
    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.overview_table_icons__xld9A {
    font-Size: 10px;
    display: block;
}

.overview_table_titles__EcJ-8 {
    color: white;
    background-Color: #83a4cf;
    cursor: pointer;
}

.overview_vehicle_details_table__9h5Ne {
    border-Radius: 10px;
    overflow: hidden;
}

.overview_vehicle_details_tableheader__Fqwjz {
    color: white;
    background-Color: #83a4cf;
}

.overview_tab_bar__EuRL0 {
    border-bottom: #83a4cf 4px solid !important;
    border-radius: 2px !important;
    color: #83a4cf !important;
}

.overview_nav_bar_buttons__cZkPr {
    background-color: transparent;
    border: none;
    font-weight: 800;
    font-size: 14px;
    color: gray
}

.overview_filter_dropdown__s1jzz {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;

}

/* check box */
.overview_checkboxWrapper_bus__AAR7- {
    position: relative;
    padding-left: 24px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}

.overview_checkboxInput_bus__xSum4 {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #ccc;
    border-radius: 3px;
    background-color: #e6e6e6;
    position: relative;
    cursor: pointer;
    margin-right: 8px;
}

.overview_checkboxInput_bus__xSum4:checked {
    display: flex;
    background-color: #83a4cf;
    border-color: #83a4cf;
}

.overview_checkboxInput_bus__xSum4:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.overview_tabs_overview__e8B9K {
    /* background-color: white; */
    /* border-radius: 5px */
    margin: 0.7rem
}

.overview_tab_overview__PCEmw {
    border-bottom: #83a4cf 4px solid !important;
    border-radius: 2px !important;
    color: #83a4cf !important;
}

.overview_filter-tab-strip__5QFLQ {
    background: #ffffff;
    border-bottom: 2px solid #E0E0E0;
    border-radius: 12px 12px 0 0;
    padding: 10px 20px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

}

.overview_filter-tab-strip__5QFLQ .overview_tab-label__PNCCk {
    font-weight: 600;
    color: #358696;
    font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/Overview_Tab_bus/overview.module.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;;;AAIA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb;;;;;yBAKqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE,YAAY;IACZ,wCAAwC;IACxC,sCAAsC;IACtC,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;;AAE7C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB","sourcesContent":[".bg_screen {\n    background-color: #f1f2fb\n}\n\n\n\n.tabs {\n    /* background-color: white; */\n    /* border-radius: 5px */\n    margin: 0.7rem\n}\n\n.disclaimer {\n    font-style: italic\n}\n\n.month {\n    cursor: pointer;\n    color: #1467b3;\n    font-size: 20px;\n    margin-right: 10px\n}\n\n.kpi {\n    box-shadow: 0 4px 6px #cdd5eb;\n    height: 100px;\n    background-color: white;\n    border: 1px solid #83A4CF;\n    border-radius: 5px;\n    width: 100%\n}\n\n.download_button {\n    color: #83a4cf;\n    background-color: transparent;\n    border: none;\n}\n\n.icons {\n    background-Color: #e4e8f6;\n    border-Radius: 50%;\n    padding: 10px;\n    /* width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-Content: center;\n    margin-Right: 10px; */\n}\n\n.number_of_vehicles {\n    color: black;\n    font-Weight: 700;\n    font-size: 20px;\n    margin-Bottom: 5px;\n}\n\n.vehicles_performance {\n    color: gray;\n    font-Weight: 500;\n    font-Size: 14px;\n    display: flex;\n    align-Items: center;\n}\n\n.cost_savings_tab {\n    background-Color: white;\n    border-radius: 10px;\n    margin-Bottom: 20px;\n    border: 1px solid #83A4CF;\n    display: flex;\n    justify-Content: space-between;\n    align-items: center;\n    box-Shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.potential_cost_savings {\n    color: #364e69;\n    font-Weight: bold;\n    margin-Bottom: 10px;\n}\n\n.potential_cost_savingstext {\n    color: #666;\n    font-Size: 14px;\n}\n\n.fuel_efficiency_tab {\n    background-Color: white;\n    border: 1px solid #83A4CF;\n    border-Radius: 5px;\n    width: 100%;\n}\n\n.fuel_efficiency_tabtext {\n    color: #364e69;\n    margin-Bottom: 5px;\n}\n\n.parameter_sel_tab {\n    border: 1px solid #83A4CF;\n    border-Radius: 10px;\n    width: 100%;\n    background-Color: #e1e6ed;\n}\n\n.parameter_distance {\n    color: #364e69;\n    font-Weight: bold;\n    margin-Bottom: 5px;\n}\n\n.button_apply {\n    background-Color: #00005f;\n    background-Image: linear-gradient(to left, #83a4cf 0%, #83a4cf 100%);\n    color: white;\n    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease-in-out;\n    border: none;\n\n}\n\n.vehicle_details {\n    border-Radius: 10px;\n    overflow: hidden;\n    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.table_icons {\n    font-Size: 10px;\n    display: block;\n}\n\n.table_titles {\n    color: white;\n    background-Color: #83a4cf;\n    cursor: pointer;\n}\n\n.vehicle_details_table {\n    border-Radius: 10px;\n    overflow: hidden;\n}\n\n.vehicle_details_tableheader {\n    color: white;\n    background-Color: #83a4cf;\n}\n\n.tab_bar {\n    border-bottom: #83a4cf 4px solid !important;\n    border-radius: 2px !important;\n    color: #83a4cf !important;\n}\n\n.nav_bar_buttons {\n    background-color: transparent;\n    border: none;\n    font-weight: 800;\n    font-size: 14px;\n    color: gray\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n\n}\n\n/* check box */\n.checkboxWrapper_bus {\n    position: relative;\n    padding-left: 24px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n}\n\n.checkboxInput_bus {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #ccc;\n    border-radius: 3px;\n    background-color: #e6e6e6;\n    position: relative;\n    cursor: pointer;\n    margin-right: 8px;\n}\n\n.checkboxInput_bus:checked {\n    display: flex;\n    background-color: #83a4cf;\n    border-color: #83a4cf;\n}\n\n.checkboxInput_bus:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 4px;\n    top: 0px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.tabs_overview {\n    /* background-color: white; */\n    /* border-radius: 5px */\n    margin: 0.7rem\n}\n\n.tab_overview {\n    border-bottom: #83a4cf 4px solid !important;\n    border-radius: 2px !important;\n    color: #83a4cf !important;\n}\n\n.filter-tab-strip {\n    background: #ffffff;\n    border-bottom: 2px solid #E0E0E0;\n    border-radius: 12px 12px 0 0;\n    padding: 10px 20px;\n    margin-bottom: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n}\n\n.filter-tab-strip .tab-label {\n    font-weight: 600;\n    color: #358696;\n    font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg_screen": `overview_bg_screen__JzMR6`,
	"tabs": `overview_tabs__i5Wvp`,
	"disclaimer": `overview_disclaimer__FLst8`,
	"month": `overview_month__vd0xz`,
	"kpi": `overview_kpi__E5Dpw`,
	"download_button": `overview_download_button__G9uaQ`,
	"icons": `overview_icons__Yxktz`,
	"number_of_vehicles": `overview_number_of_vehicles__0bQdP`,
	"vehicles_performance": `overview_vehicles_performance__zRDc2`,
	"cost_savings_tab": `overview_cost_savings_tab__G0Xr4`,
	"potential_cost_savings": `overview_potential_cost_savings__e3PaV`,
	"potential_cost_savingstext": `overview_potential_cost_savingstext__qmCMQ`,
	"fuel_efficiency_tab": `overview_fuel_efficiency_tab__z0k7R`,
	"fuel_efficiency_tabtext": `overview_fuel_efficiency_tabtext__lunqo`,
	"parameter_sel_tab": `overview_parameter_sel_tab__Uxddk`,
	"parameter_distance": `overview_parameter_distance__FDKDW`,
	"button_apply": `overview_button_apply__GXIm7`,
	"vehicle_details": `overview_vehicle_details__7hP+E`,
	"table_icons": `overview_table_icons__xld9A`,
	"table_titles": `overview_table_titles__EcJ-8`,
	"vehicle_details_table": `overview_vehicle_details_table__9h5Ne`,
	"vehicle_details_tableheader": `overview_vehicle_details_tableheader__Fqwjz`,
	"tab_bar": `overview_tab_bar__EuRL0`,
	"nav_bar_buttons": `overview_nav_bar_buttons__cZkPr`,
	"filter_dropdown": `overview_filter_dropdown__s1jzz`,
	"checkboxWrapper_bus": `overview_checkboxWrapper_bus__AAR7-`,
	"checkboxInput_bus": `overview_checkboxInput_bus__xSum4`,
	"tabs_overview": `overview_tabs_overview__e8B9K`,
	"tab_overview": `overview_tab_overview__PCEmw`,
	"filter-tab-strip": `overview_filter-tab-strip__5QFLQ`,
	"tab-label": `overview_tab-label__PNCCk`
};
export default ___CSS_LOADER_EXPORT___;
